<template>
  <div class="surveyList">
    <div v-if="loader">
      <Loader/>
    </div>
    <div v-else class="banner">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="banner-text">
              <table class="table table-striped">
                <tr>
                  <th>{{surveyName}}</th>
                  <th></th>
                  <th>{{enteredAt}}</th>
                  <th>{{tookAt}}</th>
                </tr>
                <tbody>
                  <tr v-for="survey in sortedSurvey" :key="survey.survey_id">
                    <td>
                      <h6 v-if="language == 'ja'">{{survey.title.ja}}</h6>
                      <h6 v-else>{{survey.title.default}}</h6>
                    </td> 
                    <td>
                      <div v-if="survey.title.default == surveyText6">
                        <router-link class="button" :to="'/surveys/' + survey.survey_id">
                          {{buttonText}}
                        </router-link>
                      </div>
                      <div v-else-if="survey.title.default == surveyText7">
                        <router-link class="button" :to="'/surveys/' + survey.survey_id">
                          {{buttonText}}
                        </router-link>
                      </div>
                      <div v-else>
                        <router-link class="button" :to="'/surveyDetails/' + survey.survey_id">
                          {{buttonText}}
                        </router-link>
                      </div>
                    </td> 
                    <td>
                      <div v-for="(completedSurvey, i) in user.user_surveys" :key="i">
                        <a class="text-success" v-if="survey.id == completedSurvey.survey_id">
                          {{completedSurvey.created_at | moment}}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div v-for="(completedSurvey, i) in user.user_surveys" :key="i">
                        <a class="text-success" v-if="survey.id == completedSurvey.survey_id">
                          {{completedSurvey.took_at}}
                        </a>
                      </div>
                    </td> 
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Api from "@/services/api"
import { mapState } from "vuex";
import moment from 'moment'

export default {
  name: 'SurveyList',
  filters: {
    moment (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  },
  components: {
    Loader: () => import('@/components/Loader.vue')
  },
  data () {
    return {
      // date: moment (),
      loader: true,
      userCompletedSurveys: [],
      surveyResult: [],
      buttonText: '始めましょう',
      completeText: 'がこの調査を受けました',
      userText: 'ユーザー',
      language: this.$store.state.siteLanguage,
      surveyName: 'アンケート名',
      enteredAt: '入力日',
      tookAt: '答えた日',
      surveyText6: 'HADS',
      surveyText7: 'FSCALE',
    }
  },
  created () {
    // this.$store.commit('setIsLoading', true)
    this.setLanguage(this.$store.state.siteLanguage);

    Api.get('/surveys')
      .then(response => {
        if(response.data.surveys) {
          // this.$store.commit('setIsLoading', false)
          this.loader = false;

          this.surveyResult = response.data.surveys;
          // this.surveyResult.locale = this.$store.state.siteLanguage;
          // console.log('survey list', JSON.stringify(this.surveyResult))
          localStorage.setItem('numberOfSurvey', this.surveyResult.length)
          // console.log('survey list1', JSON.stringify(this.surveyResult[5]))
          // console.log('user is', this.personID)
        }
      })
      .catch(error => {
        // console.log(error)
      })
      .finally(()=>{
        
    })
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    personID () {
      // return this.$store.state.personId
      return localStorage.getItem('setPersonId')
    },
    SiteLanguage () {
      return this.$store.state.siteLanguage
    },
    sortedSurvey: function () {
      function compare (a, b) {
        if (a.survey_id < b.survey_id)
          return -1;
        if (a.survey_id > b.survey_id)
          return 1;
        return 0;
      }

      return this.surveyResult.sort(compare);
    }
  },
  mounted(){
    let user = localStorage.getItem('user');
    if(user) {
      let userObj = JSON.parse(user)
      Api.get(`/user/${userObj.person_id}`).then(res => {
        this.$store.commit('setUser', res.data)
      }).catch(err => {
        console.log(err)
      })
    }
  },
  watch: {
    SiteLanguage (newSiteLanguage, oldSiteLanguage) {
      this.setLanguage(newSiteLanguage);
      this.language = newSiteLanguage;
    }
  },
  methods: {
    setLanguage(siteLanguage){
      if(siteLanguage==="ja"){
        this.buttonText = '始めましょう';
        this.completeText = 'がこの調査を受けました'
        this.userText = 'ユーザー'
        this.surveyName= 'アンケート名';
        this.tookAt= '答えた日';
        this.enteredAt= '入力日';
      }
      else{
        this.buttonText = 'Get Started';
        this.completeText = 'took this survey at'
        this.userText = 'User'
        this.surveyName= 'Survey Name';
        this.tookAt= 'Took At';
        this.enteredAt= 'Entered At';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.surveyList {
  position: relative;
}
.banner {
  // height: 100vh;
  height: 100%;
}
.banner-text {
  padding-top: 0px;
  text-align: center;
}
</style>

